// Набор порогов словами — для тех, кто пороги точки только видит (T-047).

import { ru, t, type MessageKey } from '@/shared/i18n';

/** «за половину срока и за 1 ч до конца» — подписи порогов из `alerts.tier.*` T-046. */
export function describeTiers(tiers: readonly string[]): string {
  const known = tiers.filter((tier) => isMessageKey(`alerts.tier.${tier}`));
  const words = known.map((tier) =>
    tier === 'expiring'
      ? t('alerts.location.half')
      : t('alerts.location.lead').replace('{label}', t(`alerts.tier.${tier}` as MessageKey)),
  );
  const joined =
    words.length > 1
      ? `${words.slice(0, -1).join(', ')} ${t('alerts.location.and')} ${words.at(-1)}`
      : (words[0] ?? '');
  return known.some((tier) => tier !== 'expiring')
    ? `${joined} ${t('alerts.location.untilEnd')}`
    : joined;
}

function isMessageKey(key: string): key is MessageKey {
  return Object.hasOwn(ru, key);
}
